<a class="skip-link" href="#main-content">{{ 'a11y-skip-to-content' | translate }}</a>
<div class="app-container has-navbar-fixed-top" id="app">
    <app-header></app-header>
    <main class="content" id="main-content" tabindex="-1">
        <router-outlet></router-outlet>
    </main>

    <app-loading [centered]="true" [firstLoad]="true"></app-loading>

    <div class="lay-wrapper lay-wrapper--footer">
        <app-scf-footer id="lay-wrapper-footer-section"></app-scf-footer>
    </div>
</div>
